/* istanbul ignore file */
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { tabQueryParam } from '../../../../../model/constants/query-param.constants';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'app-tech-services-tabs',
  templateUrl: './tech-services-tabs.component.html',
  styleUrls: ['./tech-services-tabs.component.scss'],
})
export class TechServicesTabsComponent implements OnInit {
  @Input() offers: Array<string>;
  @Input() contractId: string;
  @Input() userEmail: string;
  @Input() userType: string;
  @Input() usersOnContract: number;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  selectedTab: number;
  offerIcons = {};
  active = {};

  constructor(
    private route: ActivatedRoute,
    private resourceService: ADPResourceService
  ) {}

  ngOnInit() {
    this.selectedTab = this.getTabSelectionIndex();
    // set the icons
    this.offers.forEach((offer) => {
      this.offerIcons[offer] = this.getSetting(offer + '_Icon');
    });
    this.setSelection(this.selectedTab);
  }

  getSetting(name: string): string {
    return this.resourceService.getPortalSetting(name).Value;
  }

  onTabChange(tabChangeEvent: MatTabChangeEvent) {
    this.setSelection(tabChangeEvent.index);
  }

  setSelection(index: number) {
    if (this.offers && this.offers.length) {
      this.active[this.offers[index]] = true;
      this.offers.forEach((x, i) => {
        if (i !== index) {
          this.active[this.offers[i]] = false;
        }
      });
    }
  }

  getTabSelectionIndex() {
    const tab = Number(this.route.snapshot.queryParams[tabQueryParam]);
    const isOffersExists = this.offers && this.offers.length;
    return isNaN(tab) || tab < 1 ? 0 : !isOffersExists || (isOffersExists && tab > this.offers.length) ? 0 : tab - 1;
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
